// karriere.at ATS USER UUID
export const KARRIERE_ATS_USER_UUID = '8dc72fa1-d288-5f60-9edd-078830618466';
